export default __webpack_public_path__ + "static/pic10-8894d0a7875b9fb97e4aa6762cfd15cb.jpg";